export default {
  namespaced: true,
  state: {
    // 清除keep-alive的指定的组件的缓存
    excludeName: []
  },
  getters: {
    excludeName (state) {
      return state.excludeName
    }
  },
  mutations: {
    Set_Exclude_Name (state, data) {
      state.excludeName = data
    }
  },
  actions: {
    // 设置要清除的组件缓存
    setExcludeName ({ commit }, params) {
      commit('Set_Exclude_Name', params)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/keepAlive.js